// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Ti7V","title":"Info_title__219xo","links":"Info_links__2DtuI","link":"Info_link__21Ne5","logo":"Info_logo__3GI_o"};